'use strict';

var GlobalNotificationsConstants = {
  GLOBAL_NOTIFACATION_TABS: {
    GLOBAL: 'globalTab',
    CATEGORY2: 'category2Tab'
  },
  GLOBAL_NOTIFICATION_PANEL_TITLE_PREFIX: {
    GLOBAL: 'Global',
    CATEGORY2: 'Category 2'
  }
};
module.exports = GlobalNotificationsConstants;